import styled from 'styled-components'
import { baseTheme } from 'primsell-shared-layer/styles/theme'

export const SecondaryLayout = styled.div`
  background: ${baseTheme.colors.nearWhite};
  min-height: 100vh;
  width: 100%;

  display: flex;
  justify-content: center;

  align-items: start;

  @media ${baseTheme.device.mobileL} {
    align-items: center;
    padding-top: 48px;
    padding-bottom: 48px;
  }
`
